const utilities = {
  install(Vue) {
    Vue.prototype.$utilities = {
      // example: How to call function
      // 1.) this.$utils('functionsName', {Parameters})
      // 2.) Vue.prototype.$utilities.functionName(Parameters)
      acronymName: (value) => {
        // 1.) { fullname: 'string' }
        // 2.) { firstName: 'string', lastName: 'string' }
        let firstNameText, lastNameText
        if (value.fullName) {
          firstNameText = value.fullName.split(" ")[0].charAt(0)
          lastNameText = value.fullName.split(" ").reverse()[0].charAt(0)
          if (firstNameText === lastNameText) { lastNameText = "" }
        } else {
          firstNameText = value.firstName ? value.firstName.charAt(0) : ""
          lastNameText = value.lastName ? value.lastName.charAt(0) : ""
        }
        return firstNameText + lastNameText
      },
      addCommasInNumber: (value) => {
        // 1.) { number }
        // 2.) { 'number' } -- Typeof value is string, but real value is number!
        let num, oneDigit, str
        if (value === undefined || value === null) {
          return "0"
        } else if (typeof value === 'number') {
          num = value.toFixed(2)
        } else {
          num = value
        }

        str = num.toString().split('.')
        if (str[0].length >= 4) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
        }
        if (str[1]) {
          oneDigit = str[1].split('')
          if (str[1] === '00') {
            str = str[0]
          } else if (oneDigit[1] === '0') {
            str[1] = oneDigit[0]
            str = str.join('.')
          } else {
            str = str.join('.')
          }
        } else {
          str = str[0]
        }
        return str
      },
      placeholderInTable: (val) => {
        // 1.) { loadingLoop: number, table: number, textLoading: ' ', textEmpty: string, textNotFound: string }
        if (!val.loadingLoop) {
          return val.textLoading || ' '
        } else if (val.loadingLoop === 1 && val.table === 0) {
          return val.textEmpty || ' '
        } else {
          return val.textNotFound || ' '
        }
      },
      fontStyle: (text) => {
        // 1.) { string }
        if (text.match(/[ก-๙]/)) {
          return "font-family: Kanit"
        } else {
          return "font-family: Lato"
        }
      },
      watchingTrim: (val) => {
        // 1.) { string }
        // 2.) { text: string, min: number }
        let min = val.min || 0
        let textLenght = 0;
        if (typeof val === 'string') {
          textLenght = val.trim().length
        } else if (typeof val === 'number') {
          textLenght = val.toString().trim().length
        } else if (val.text) {
          textLenght = val.text.trim().length
        }
        if (textLenght > min) {
          return true
        } else {
          return false
        }
      },
      validateInt: (val) => {
        // 1.) { any }
        let reg = /^[0-9]*$/
        return reg.test(val)
      },
      validateEmail: (val) => {
        // 1.) { string }
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return reg.test(val)
      },
      mockingID(length) {
        // 1.) { number }
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
      removeHashURL(val) {
        // 1.) { hash:string, anchor:obj, default:string }
        const anchor = val.hash.split('#');
        const checkedHash = val.anchor[anchor[1]];
        // return anchor[1] || false;
        if (anchor[1] && checkedHash) {
          return anchor[1];
        } else {
          return val.default;
        }
      },
      maxHeightChart(val) {
        // 1.) { number }
        let number = Number(val.number) || val;
        let value = val.number || val;
        number = Number(number);
        if (number > 100) {
          if (val.size && val.size < 250) {
            value = (number + number * (20 / 100)).toFixed(0);
          } else {
            value = (number + number * (14 / 100)).toFixed(0);
          }
        } else if (number > 10) {
          value = (number + number * (20 / 100)).toFixed(0);
        } else if (value > 0) {
          value = number + 1;
        } else {
          value = (number + number * (13 / 100)).toFixed(0);
        }
        return value
      },
      waitingTime(ms) {
        // 1.) { number }
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      icons(name) {
        // 1.) { string }
        return require("@/assets/icons/" + name + ".png")
      }
    }
    Vue.mixin({
      data() {
        return {
          get variable() {
            return {
              // Global variables!
              typingTimeout: 200,
              // appVersion: ''
            }
          }
        }
      },
      methods: {
        $utils(functionName: string, value: any) {
          switch (functionName) {
            case 'acronymName':
              return Vue.prototype.$utilities[functionName](value)
            case 'addCommasInNumber':
              return Vue.prototype.$utilities[functionName](value)
            case 'placeholderInTable':
              return Vue.prototype.$utilities[functionName](value)
            case 'fontStyle':
              return Vue.prototype.$utilities[functionName](value)
            case 'watchingTrim':
              return Vue.prototype.$utilities[functionName](value)
            case 'validateInt':
              return Vue.prototype.$utilities[functionName](value)
            case 'validateEmail':
              return Vue.prototype.$utilities[functionName](value)
            case 'mockingID':
              return Vue.prototype.$utilities[functionName](value)
            case 'removeHashURL':
              return Vue.prototype.$utilities[functionName](value)
            case 'maxHeightChart':
              return Vue.prototype.$utilities[functionName](value)
            case 'waitingTime':
              return Vue.prototype.$utilities[functionName](value)
            case 'icons':
              return Vue.prototype.$utilities[functionName](value)
            case 'test':
              console.log('[utils] Utils Work!')
              break
            default:
              console.warn(`[utils] Don't have function: ${functionName}.`)
          }
        }
      }
    })
  }
}

import Vue from 'vue'
Vue.use(utilities)
